import { reportingTabs } from './tabs.js';
import { reportingQueryString } from './query-string.js';
import { uoReportingAPI } from './api-call.js';

export function ls(string) {
	if (typeof reportingApiSetup.localizedStrings[string] !== 'undefined') {
		return reportingApiSetup.localizedStrings[string];
	} else {
		return string;
	}
}

document.addEventListener('DOMContentLoaded', function () {

	if (window.jQuery && window.jQuery.fn && window.jQuery.fn.dataTable) {
		window.jQuery.fn.dataTable.ext.errMode = 'none';
	}

	// Setup Page Tab Navigation
	reportingTabs.addTabEvents();
	reportingTabs.addTableEvents();
	reportingTabs.addNavigationEvents();

	// Check Query parameters
	// If it is TinCan search, nav goes to Tin Can Tab
	reportingQueryString.init();

	var saveSettings = function(event) {
		event.preventDefault();

		// Cache inputs
		var tinCanActivation = document.querySelectorAll('input[type=radio][name=tinCanActivation]');
		var disableMarkComplete = document.querySelectorAll('input[type=radio][name=disableMarkComplete]');
		var nonceProtection = document.querySelectorAll('input[type=radio][name=nonceProtection]');

		// Disable inputs while storing data
		tinCanActivation.forEach(input => input.disabled = true);
		disableMarkComplete.forEach(input => input.disabled = true);
		nonceProtection.forEach(input => input.disabled = true);

		// Get settings values
		var tinCanActivationSelected = document.querySelector('input[type=radio][name=tinCanActivation]:checked');
		var disableMarkCompleteSelected = document.querySelector('input[type=radio][name=disableMarkComplete]:checked');
		var nonceProtectionSelected = document.querySelector('input[type=radio][name=nonceProtection]:checked');

		// Make Api Calls to save input values
		var toggleTinCan = uoReportingAPI.reportingApiCall('show_tincan', tinCanActivationSelected.value);
		var toggleMarkComplete = uoReportingAPI.reportingApiCall('disable_mark_complete', disableMarkCompleteSelected.value);
		var toggleNonceProtection = uoReportingAPI.reportingApiCall('nonce_protection', nonceProtectionSelected.value);

		toggleTinCan.done(function (response) {
			if ('1' === tinCanActivationSelected.value) {
				document.querySelector('li#menuTinCan').style.display = 'block';
				document.querySelector('a[href="#tin-can"]').style.display = 'block';
			}
			if ('0' === tinCanActivationSelected.value) {
				document.querySelector('li#menuTinCan').style.display = 'none';
				document.querySelector('a[href="#tin-can"]').style.display = 'none';
			}
			tinCanActivation.forEach(input => input.disabled = false);
			document.querySelector('#save-settings').classList.add('reporting-button-green');
		});

		toggleMarkComplete.done(function (response) {
			disableMarkComplete.forEach(input => input.disabled = false);
			document.querySelector('#save-settings').classList.add('reporting-button-green');
			setTimeout(function() {
				document.querySelector('#save-settings').classList.remove('reporting-button-green');
			}, 2500);
		});

		toggleNonceProtection.done(function (response) {
			nonceProtection.forEach(input => input.disabled = false);
			document.querySelector('#save-settings').classList.add('reporting-button-green');
			setTimeout(function() {
				document.querySelector('#save-settings').classList.remove('reporting-button-green');
			}, 2500);
		});
	};

	var resetTinCanData = function(event) {
		event.preventDefault();
		var text = ls('Are you sure you want to permanently delete all Tin Can data? This cannot be undone.');
		if (!confirm(text)) return;

		document.querySelector('#btnResetTinCanData').disabled = true;

		var callResetTinCanData = uoReportingAPI.reportingApiCall('reset_tincan_data');
		callResetTinCanData.done(function(response) {
			document.querySelector('#btnResetTinCanData').disabled = false;
			document.querySelector('.uo-admin-reporting-tab-single#tin-can .tablenav-pages').innerHTML = '';
			document.querySelector('.uo-admin-reporting-tab-single#tin-can .tablenav.bottom').innerHTML = '';
			var wpListTable = document.querySelector('.uo-admin-reporting-tab-single#tin-can .wp-list-table');
			if (wpListTable) wpListTable.remove();
		});
	};

	var resetQuizData = function(event) {
		event.preventDefault();
		var text = ls('Are you sure you want to permanently delete all Quiz data? This cannot be undone.');
		if (!confirm(text)) return;

		document.querySelector('#btnResetQuizData').disabled = true;

		var callResetQuizData = uoReportingAPI.reportingApiCall('reset_quiz_data');
		callResetQuizData.done(function(response) {
			document.querySelector('#btnResetQuizData').disabled = false;
			document.querySelector('.uo-admin-reporting-tab-single#xapi-tincan .tablenav-pages').innerHTML = '';
			document.querySelector('.uo-admin-reporting-tab-single#xapi-tincan .tablenav.bottom').innerHTML = '';
			var wpListTable = document.querySelector('.uo-admin-reporting-tab-single#xapi-tincan .wp-list-table');
			if (wpListTable) wpListTable.remove();
		});
	};

	var resetBookmarkCanData = function(event) {
		event.preventDefault();
		var text = ls('Are you sure you want to permanently delete all Bookmark data? This cannot be undone.');
		if (!confirm(text)) return;

		document.querySelector('#btnResetBookmarkData').disabled = true;

		var callbtnResetBookmarkData = uoReportingAPI.reportingApiCall('reset_bookmark_data');
		callbtnResetBookmarkData.done(function(response) {
			document.querySelector('#btnResetBookmarkData').disabled = false;
		});
	};

	var purgeExperienced = function(event) {
		event.preventDefault();
		var text = ls('Are you sure you want to permanently delete all saved xApi statements with the "Experienced" verb? This cannot be undone.');
		if (!confirm(text)) return;

		document.querySelector('#btnPurgeExperienced').disabled = true;

		var callbtnPurgeExperienced = uoReportingAPI.reportingApiCall('purge_experienced');
		callbtnPurgeExperienced.done(function(response) {
			document.querySelector('#btnPurgeExperienced').disabled = false;
		});
	};

	var purgeAnswered = function(event) {
		event.preventDefault();
		var text = ls('Are you sure you want to permanently delete all saved xApi statements with the "Answered" verb? This cannot be undone.');
		if (!confirm(text)) return;

		document.querySelector('#btnPurgeAnswered').disabled = true;

		var callbtnPurgeAnswered = uoReportingAPI.reportingApiCall('purge_answered');
		callbtnPurgeAnswered.done(function(response) {
			document.querySelector('#btnPurgeAnswered').disabled = false;
		});
	};

	var purgeVerbStatements = function(event) {
		event.preventDefault();
		var text = 'Are you sure you want to permanently delete the selected verb\'s statements? This cannot be undone.';
	
		if (!confirm(text))
			return;
	
		var verb = document.getElementById('uotc_purge_verb').value;
	
		if (verb.trim() === '') {
			document.getElementById('uotc_purge_verb').focus();
			return;
		}
	
		var payload = {
			uotc_verb: verb
		};
	
		var button = document.getElementById('btnPurgeVerbStatements');
		button.disabled = true;
	
		uoReportingAPI.reportingApiCallDataPost('purge_verb_statements', payload)
			.done(function(response) {
				button.disabled = false;
			});
	};	

	// On Click save settings button store user input selections
	const saveSettingsButton = document.querySelector('#save-settings');
	if (saveSettingsButton) {
		saveSettingsButton.addEventListener('click', saveSettings);
	}

	// On Click Reset Tin Can Data button
	const resetTinCanDataButton = document.querySelector('#btnResetTinCanData');
	if (resetTinCanDataButton) {
		resetTinCanDataButton.addEventListener('click', resetTinCanData);
	}

	// On Click Reset Quiz Data button
	const resetQuizDataButton = document.querySelector('#btnResetQuizData');
	if (resetQuizDataButton) {
		resetQuizDataButton.addEventListener('click', resetQuizData);
	}

	// On Click Reset Bookmark Data button
	const resetBookmarkDataButton = document.querySelector('#btnResetBookmarkData');
	if (resetBookmarkDataButton) {
		resetBookmarkDataButton.addEventListener('click', resetBookmarkCanData);
	}

	// On Click Purge Experienced button
	const purgeExperiencedButton = document.querySelector('#btnPurgeExperienced');
	if (purgeExperiencedButton) {
		purgeExperiencedButton.addEventListener('click', purgeExperienced);
	}

	// On Click Purge Answered button
	const purgeAnsweredButton = document.querySelector('#btnPurgeAnswered');
	if (purgeAnsweredButton) {
		purgeAnsweredButton.addEventListener('click', purgeAnswered);
	}

	// On Click Purge Answered button
	const purgeVerbStatementsButton = document.querySelector('#btnPurgeVerbStatements');
	if (purgeVerbStatementsButton) {
		purgeVerbStatementsButton.addEventListener('click', purgeVerbStatements);
	}

});
